import Dialog from '@mui/material/Dialog'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React from 'react'

const HHBaseDialog = ({ children, onClose = noop, paperPropsSx = {}, ...rest }) => (
  <Dialog PaperProps={{ sx: { maxHeight: 'calc(100% - 128px)', ...paperPropsSx } }} onClose={onClose} {...rest}>
    {children}
  </Dialog>
)

HHBaseDialog.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  paperPropsSx: PropTypes.object,
}

export default HHBaseDialog
